// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import type { OrgCloneWizardFieldData } from "src/types";

import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from "@chakra-ui/react";
import * as styles from "./Email.styles";

type Props = {
  email: OrgCloneWizardFieldData,
  onChange: Function,
};

export default function Email({ email, onChange }: Props) {
  return (
    <FormControl isInvalid={email.error} isRequired sx={styles.formControl}>
      <FormLabel>{i18n.t(k.EMAIL1)}</FormLabel>
      <Input
        value={email.value}
        onChange={(e) => onChange(e.target.value)}
        type="email"
      />

      <FormErrorMessage>{email.error}</FormErrorMessage>
    </FormControl>
  );
}
